// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"e00f2378","884":"bdbefe00"}[chunkId] + ".chunk.js";
};